var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticStyle:{"overflow":"hidden"},style:(_vm.inlineStyle),attrs:{"data-id":_vm.dataId}},[(_vm.isLoading)?_c('div',{staticClass:"display-flex-center",style:({ height: _vm.height + 'px' })},[_c('inline-preloader',{attrs:{"text":"Attaching banner..."}})],1):_vm._e(),_c('div',{ref:"mountPoint"})])
}
var staticRenderFns = []

export { render, staticRenderFns }